import SpotController from './SpotController.js';

export default class {
  constructor() {
    // ページ判定してSpotControllerまたはMapを初期化
    const currentPage = document.body.dataset.page || window.location.pathname;

    if (currentPage.includes('map') || document.getElementById('map')) {
      // map/index.htmlページの場合
      new SpotController();
    }
  }
}
